// src/components/common/ToggleGroup.js
import React from 'react';

/**
 * ToggleGroup - Reusable toggle button group component
 *
 * @param {Array} options - Array of { value, label } objects
 * @param {string} value - Currently selected value
 * @param {function} onChange - Callback when selection changes
 * @param {number} columns - Optional: for grid layout (e.g., 2 for 2x2 grid)
 */
const ToggleGroup = ({ options, value, onChange, columns }) => {
  // Smaller font for groups with 4+ options to prevent truncation
  const baseFontSize = options.length >= 4 ? 12 : 13;

  const containerStyle = columns ? {
    display: 'grid',
    gridTemplateColumns: `repeat(${columns}, 1fr)`,
    gap: '4px',
    width: '100%',
  } : {
    display: 'flex',
    width: '100%',
    border: '1px solid #E5E7EB',
    borderRadius: '8px',
    overflow: 'hidden',
  };

  const buttonStyle = (isSelected) => ({
    flex: columns ? undefined : 1,
    padding: '8px 2px',
    minHeight: '40px',
    fontSize: `${baseFontSize}px`,
    fontWeight: isSelected ? 500 : 400,
    textAlign: 'center',
    cursor: 'pointer',
    border: columns ? '1px solid ' + (isSelected ? '#7c3aed' : '#E5E7EB') : 'none',
    borderRight: !columns ? '1px solid #E5E7EB' : undefined,
    borderRadius: columns ? '8px' : 0,
    background: isSelected ? '#7c3aed' : '#FFFFFF',
    color: isSelected ? '#FFFFFF' : '#4B5563',
    transition: 'all 0.15s ease',
    whiteSpace: 'normal',
    lineHeight: '1.2',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  });

  return (
    <div style={containerStyle}>
      {options.map((opt, i) => (
        <button
          key={opt.value}
          type="button"
          onClick={() => onChange(opt.value)}
          style={{
            ...buttonStyle(value === opt.value),
            // Remove right border on last item for non-grid
            ...((!columns && i === options.length - 1) ? { borderRight: 'none' } : {}),
          }}
        >
          {opt.label}
        </button>
      ))}
    </div>
  );
};

export default ToggleGroup;
